import type { GridRowModel } from '@packages/fenrir/components';

import { AssetNetworkContent } from '../asset-network-content/asset-network-content';

type AssetTableDetailProps = {
  row: GridRowModel;
};

export const AssetTableDetail = ({ row }: AssetTableDetailProps) => (
  <AssetNetworkContent assetId={row.id} padding={4} />
);
